import { forwardRef, ImgHTMLAttributes, useState } from 'react'

type CustomImageProps = ImgHTMLAttributes<HTMLImageElement>
export const CustomImage = forwardRef<HTMLImageElement, CustomImageProps>((props, ref) => {
  const [disable, setDisable] = useState(false)
  return disable ? <></> : <img ref={ref} onError={() => setDisable(true)} {...props}></img>
})

CustomImage.displayName = 'CustomImage'
